import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal__vms-template-wrapper" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "vms-loading"
}
const _hoisted_4 = {
  key: 2,
  class: "modal__vms-content"
}
const _hoisted_5 = {
  key: 0,
  class: "modal__vms-image-box"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "modal__vms-datetime" }
const _hoisted_8 = {
  key: 1,
  class: "modal__vms-image-off"
}
const _hoisted_9 = { class: "modal__vms-image-off-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.modalData.description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal__vms-description",
            innerHTML: _ctx.modalData.description
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "secondary",
              size: "50"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.vmsDetails.code && _ctx.vmsDetails.mime_type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: `data:${_ctx.vmsDetails.mime_type};base64,${_ctx.vmsDetails.code}`,
                    alt: "vms-image"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatDate(_ctx.vmsDetails.date_time)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[0] || (_cache[0] = _createElementVNode("i", { class: "mdi mdi-eye-off" }, null, -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_translated_text_component, { translation: "modal_vms_no_image_text" })
                  ])
                ]))
          ]))
    ])
  ]))
}